import React, { useEffect, useState, useRef } from "react"
import InputField from "../../InputField"
import Select from "react-select"
import { getDrugById } from "../../../core/services/api"
import Toast from "../../Toast"
import CreatableSelect from "react-select/creatable"
import { getFrequencies, updateFrequencies, filterWondersoftDrugs } from "core/services/api"
import { useSelector } from "react-redux"


export default function WondersoftRow({
  provider,
  index,
  eachPrescription,
  selectedInputValue,
  setSelectedInputValue,
  isEditable,
  onValueChange,
  onDelete,
  isReadOnly,
  freezePrescription,
  allDrugs,
  lengthMed,
  i,
  setSideEffectsToEmpty
}: any): JSX.Element {
  // const medicineType: string[] = ["TAB", "INJ", "KIT", "CAP", "SYP", "CRM", "GEL", "DRP", "SUS", "LIQ", "POW", "SAC", "EXP", "OIN", "GEN", "LOT", "GRA", "SOAP", "SOL", "VAC", "PAS", "INH", "OTH", "SPR"]

  const medicineType: string[] = [
    '1UNIT', 'CAPSULE',
    'CARTRIDGE', 'CREAM',
    'GEL', 'INJECTION',
    'IV', 'LIQUID',
    'MACHINE', 'PATCH',
    'PCS', 'PFS',
    'POWDER', 'SACHET',
    'SOLUTION', 'STRIPS',
    'SUSPENSION', 'SYRUP',
    'TAB', 'TABLET',
    'VACCINE', 'VAIL'
  ]

  // const DoseType: string[] = ["1-0-0", "0-0-1", "1-0-1", "1-1-1", "1-1-0", "0-1-0", "0-1-1", "0-0-0-1"];

  const whenType: string[] = ["Before Food", "After Food", "Before Afternoon", "After Breakfast", "Before Lunch", "After Lunch", "Before Dinner", "After Dinner", "With Food", "With Tea", "Empty Stomach", "Bed Time", "Before Bath", "After Bath", "Before Sun", "After Sun", "SoS"]

  const frequencyType: string[] = ["Daily", "Alternate day", "Weekly", "Weekly Twice", "Weekly Thrice", "Fort Night", "Montly", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]

  const [medicineOptions, updateMedicineOptions] = useState([])
  const [medicineTypeOptions, updateMedicineTypeOptions] = useState([...medicineType])
  const [medicine, updateMedicine] = useState<any>("")
  const [totalMedicines, updateTotalMedicines] = useState<any>()
  const [drugDosage, setDrugdosage] = useState<any>()
  const [showdrugValidation, setShowdrugvalidation] = useState(false)
  const [newMedicine, setNewMedicine] = useState("")
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [selectedFreq, setSelectedFreq] = useState<any>(null);
  const selectRef = useRef<any>(null);
  const freqRef = useRef<any>(null);
  const [DoseType, setDoseType] = useState<any>([])
  const userDetail = useSelector((state: any) => state?.user?.userDetail);
  const [showToast, setShowToast] = useState(false)
  const [displayToast, toggleDisplayToast] = useState<any>()
  const [inputValueDuration, setInputValueDuration] = useState<any>('');
  const [options1, setOptions1] = useState<any>([]);

  useEffect(() => {
    if (userDetail && userDetail?.currentCenter && userDetail?.currentCenter?.centerId) {
      getFrequencies(`${userDetail?.currentCenter?.centerId}`)
        .then((res: any) => {
          if (res && res.length > 0) {
            setDoseType(res)
          } else {
            setDoseType([])
          }
        })
        .catch((err: any) => {
          console.log("frequency error", err)
        })
    }
  }, [])

  const title = medicineTypeOptions?.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const doses = DoseType?.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const whens = whenType?.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const [frequencies, setFrequencies] = useState([]);

  useEffect(() => {
    const updatedFrequencies = DoseType.map((ele: any) => {
      return { label: ele, value: ele };
    });
    setFrequencies(updatedFrequencies);
  }, [DoseType]);

  const handleCancel = () => {
    setShowToast(false);
  };

  const handleConfirm = () => {
    const updatedFreq = [...DoseType]
    updatedFreq.push(selectedFreq);
    updateFrequencies(`${userDetail?.currentCenter?.centerId}`, updatedFreq)
      .then((res: any) => {
        toggleDisplayToast({ text: "Frequency values successfully updated for the center", type: "success" });
        setDoseType(res)
      })
      .catch((err: any) => {
        toggleDisplayToast({ text: "Cannot update the frequency values for the given center", type: "error" });
      });
    console.log("Confirm action");
    setShowToast(false);
  };

  function fetchMedicine(med: any) {
    updateTotalMedicines(allDrugs)
    const temp = (allDrugs || []).map((each: any) => ({
      label: each?.brandName,
      value: each?.id,
      dpco: each?.dpco,
    }))

    const dpcoItems = temp.filter((t: any) => t.dpco && String(t.dpco).trim() !== '')
    const otherItems = temp.filter((t: any) => !t.dpco || String(t.dpco).trim() === '')
    const sortedTemp = [...dpcoItems, ...otherItems]

    updateMedicineOptions(sortedTemp)
  }

  const fetchDosage = (drugId: any) => {
    getDrugById(drugId).then((res) => {
      setDrugdosage(res)
    })
  }

  useEffect(() => {
    fetchMedicine(medicine)
  }, [allDrugs])

  const handleChange = (option: any) => {
    if (
      medicineOptions?.filter((medicine: any) => {
        return medicine?.label === option?.label
      })?.length <= 0
    ) {
      setNewMedicine(option)
      onValueChange("medicineName", option?.value, index, "")
      onValueChange("wondersoftProductCode", "", index)
    }
    else {
      const value: any = totalMedicines?.find(
        (each: any) => each?.id === option?.value
      )
      onValueChange("medicineName", value?.brandName, index, value)
      onValueChange("wondersoftProductCode", value?.alternateProductCode, index)
      onValueChange("type", value?.drugType, index)
      updateMedicineTypeOptions(value?.drugType ? [value?.drugType] : [])
      fetchDosage(value?.id)
    }
    setSideEffectsToEmpty(i, index)
  }

  const drugDosageValidation = (value: any) => {
    const numericValueDosage = parseFloat(drugDosage?.upperLimit?.match(/\d+/)[0]);
    const numericValue = parseFloat(value?.match(/\d+/)[0]);
    if (Object.keys(drugDosage).length > 0) {
      if (drugDosage?.upperLimit !== null && drugDosage?.lowerLimit !== null) {
        if (
          (numericValue > numericValueDosage)
        ) {
          setShowdrugvalidation(true)
        }
      }
    }
  }

  const handleFocus = (origin: any, i: any, j: any, value: any) => {
    const selected: any = { ...selectedInputValue }
    selected[origin][i]["medicines"][j] = value
    setSelectedInputValue(selected)
  };

  const handleFocusFreq = (origin: any, i: any, j: any, value: any) => {
    const selected: any = { ...selectedInputValue }
    selected[origin][i]["freq"][j] = value
    setSelectedInputValue(selected)
  };

  const handleBlur = (origin: any, i: any, j: any, value: any) => {
    handleFocus(origin, i, j, "")
    const elements = document.querySelectorAll('.target-classname');
    elements.forEach((element: any) => {
      if (typeof element.blur === 'function') {
        element.blur();
      }
    });
  };

  const handleBlurFreq = (origin: any, i: any, j: any, value: any) => {
    handleFocusFreq(origin, i, j, "")
    const elements = document.querySelectorAll('.target-classname');
    elements.forEach((element: any) => {
      if (typeof element.blur === 'function') {
        element.blur();
      }
    });
  };

  const filterDrugType = (drugType: any, searchText: any) => {
    let url = "";
    if (drugType) {
      url = `?drugType=${drugType}`;
    }
    if (searchText) {
      if (url === "") {
        url = `?searchText=${searchText}`;
      } else {
        url = url + `&searchText=${searchText}`;
      }
    }

    filterWondersoftDrugs(url)
      .then((res: any) => {
        const temp = (res || []).map((each: any) => ({
          label: each?.brandName,
          value: each?.id,
          dpco: each?.dpco,
        }))

        const dpcoItems = temp.filter((t: any) => t.dpco && String(t.dpco).trim() !== '')
        const otherItems = temp.filter((t: any) => !t.dpco || String(t.dpco).trim() === '')
        const sortedTemp = [...dpcoItems, ...otherItems]

        updateMedicineOptions(sortedTemp)
      })
      .catch((err: any) => {
        console.log("filter drug type error", err)
      })

  }

  const handleChangeDuration = (selectedOption: any) => {
    const inputValue = selectedOption ? selectedOption.value : '';
    setInputValueDuration(inputValue);
    const number = parseInt(inputValue);

    if (!isNaN(number)) {
      const newOptions = [
        { value: `${number} mins`, label: `${number} mins` },
        { value: `${number} hours`, label: `${number} hours` },
        { value: `${number} days`, label: `${number} days` },
        { value: `${number} weeks`, label: `${number} weeks` },
        { value: `${number} months`, label: `${number} months` },
        { value: `${number} years`, label: `${number} years` },
      ];
      setOptions1(newOptions);
    } else if ("daily".includes(inputValue.toLowerCase())) {
      setOptions1([{ value: 'Daily', label: 'Daily' }])
    } else {
      // const newOptions1 = [
      //   { value: ` days`, label: `days` },
      //   { value: ` weeks`, label: ` weeks` },
      //   { value: ` months`, label: ` months` },
      //   { value: ` years`, label: ` years` }];
      setOptions1([]);
    }
  };

  const tdRef = useRef<HTMLTableDataCellElement>(null);

  useEffect(() => {
    if (tdRef.current) {
      const textareaHeight = tdRef.current.querySelector('.consultant-dose-con')?.scrollHeight || 0;
      tdRef.current.style.height = `${textareaHeight}px`;
    }
  }, [eachPrescription?.instructions]);


  return (
    <>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
      {showToast && (
        <Toast
          textMessage="Do you want to save this frequency value for future use?"
          onCloseText="Cancel"
          onClickText="Confirm"
          onClose={handleCancel}
          onClick={handleConfirm}
          type="confirmation"
          textarea={false}
          textareaContent={null}
        />
      )}
      <tr ref={provider.innerRef} {...provider.draggableProps} className="treatment-plan-row-tr">
        <td className={` treatment-plan-row-td ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} style={{ margin: 0, padding: 5 }} {...provider.dragHandleProps} >
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", height: "100%", minWidth: "45px", justifyContent: "center" }}>
            <img src="../../../../assets/images/drag-drop-icon.svg" style={{ marginRight: "5px" }} />
            {index + 1}
          </div>
        </td>
        <td className={`col-md-2 treatment-plan-row-td ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} style={{ margin: 0, padding: 0 }}>

          <Select
            className="country-select"
            options={title}
            onChange={(option: any) => {
              filterDrugType(option?.value, "");
              onValueChange("type", option?.value, index)
              if (!newMedicine || newMedicine === "") {
                onValueChange("medicineName", "", index)
                onValueChange("wondersoftProductCode", "", index)
              }
            }}
            placeholder="Type"
            isDisabled={!isEditable || isReadOnly || freezePrescription}
            value={title?.filter(({ label }: any) =>
              label === eachPrescription?.type)?.length > 0 ? title?.filter(({ label }: any) => label === eachPrescription?.type) : { label: eachPrescription?.type, value: eachPrescription?.type }}
          />
        </td>
        <td className={`col-md-3 treatment-plan-row-td med-name-style ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} title={eachPrescription?.medicineName} style={{ margin: 0, padding: 0 }}>
          <CreatableSelect
            // ref={selectRef}
            isClearable
            value={
              eachPrescription?.medicineName
                ? medicineOptions?.filter(
                  ({ label }) => label === eachPrescription?.medicineName
                )?.length > 0 ? medicineOptions.filter(
                  ({ label }) => label === eachPrescription?.medicineName
                ) : { label: eachPrescription?.medicineName, value: eachPrescription?.medicineName }
                : newMedicine
            }
            onChange={(e: any) => {
              handleChange(e);
              handleBlur("prescription", i, index, e);
            }}
            onFocus={(e: any) => {
              handleFocus("prescription", i, index, eachPrescription?.medicineName);
              if (!eachPrescription?.medicineName) {
                filterDrugType(eachPrescription?.type, eachPrescription?.medicineName);
              }
            }}
            inputValue={selectedInputValue?.prescription[i]?.medicines[index]}
            onInputChange={(newValue: string) => {
              updateMedicineTypeOptions([...medicineType])
              if (newValue !== undefined) {
                if (newValue.length >= 3) {
                  filterDrugType(eachPrescription?.type, newValue);
                }
                const selected: any = { ...selectedInputValue };
                if (!selected["prescription"][i]) {
                  selected["prescription"][i] = { medicines: [] };
                }
                selected["prescription"][i]["medicines"][index] = newValue;
                setSelectedInputValue(selected);
              } else {
                const selected: any = { ...selectedInputValue };
                selected["prescription"][i]["medicines"][index] = "";
                setSelectedInputValue(selected);
              }
            }}
            options={medicineOptions}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
            isDisabled={!isEditable || isReadOnly || freezePrescription}

          />
        </td>
        <td className={`col-md-1 treatment-plan-row-td ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} title={eachPrescription?.dose} style={{ margin: 0, padding: 0 }}>
          <InputField
            className="consultant-dose-con"
            handleChange={(e: any) => {
              onValueChange("dose", e.target.value, index)
              // drugDosageValidation(e.target.value)
            }}
            handleBlur={(e: any) => {
              onValueChange("dose", e.target.value, index)
              drugDosageValidation(e.target.value)
            }}
            value={eachPrescription?.dose}
            readOnly={!isEditable || isReadOnly || freezePrescription}
          />

        </td>
        {/* */}
        <td className={`col-md-2 treatment-plan-row-td ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} title={eachPrescription?.when} style={{ margin: 0, padding: 0 }}>

          <CreatableSelect
            isClearable
            isDisabled={!isEditable || isReadOnly || freezePrescription}
            value={{
              label: eachPrescription?.when,
              value: eachPrescription?.when
            }}
            className="country-select"
            onChange={(e: any) => {
              onValueChange("when", e?.value, index)
            }}
            options={whens}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
          />
        </td>

        <td className={`col-md-1 treatment-plan-row-td med-name-style-freq ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} title={eachPrescription?.frequency} style={{ margin: 0, padding: 0 }}>
          <CreatableSelect
            // ref={freqRef}
            isClearable
            isDisabled={!isEditable || isReadOnly || freezePrescription}
            value={{
              label: eachPrescription?.frequency,
              value: eachPrescription?.frequency
            }}
            // defaultInputValue={eachPrescription?.medicineName}
            className="country-select"
            onChange={(e: any) => {
              handleBlurFreq("freq", i, index, e);
              onValueChange("frequency", e?.value, index)
              if (e?.value !== "") {
                if (!frequencies.map((option: any) => option.value).includes(e?.value)) {
                  console.log("inside if ", e?.value)
                  setSelectedFreq(e?.value)
                  setShowToast(true);
                } else {
                  setShowToast(false);
                }
              }
            }}
            onFocus={(e) => {
              handleFocusFreq("freq", i, index, eachPrescription?.frequency);
            }}
            inputValue={selectedInputValue?.freq[i]?.freq[index]}
            onInputChange={(newValue: string) => {
              if (newValue !== undefined) {
                const selected: any = { ...selectedInputValue };
                if (!selected["freq"][i]) {
                  selected["freq"][i] = { freq: [] };
                }
                selected["freq"][i]["freq"][index] = newValue;
                setSelectedInputValue(selected);
              }
              else {
                const selected: any = { ...selectedInputValue };
                selected["freq"][i]["freq"][index] = "";
                setSelectedInputValue(selected);
              }
            }}
            options={frequencies}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
          />
        </td>
        <td className={`col-md-2 treatment-plan-row-td ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} title={eachPrescription?.duration} style={{ margin: 0, padding: 0 }}>
          <Select
            // value={eachPrescription?.duration}
            value={{
              label: eachPrescription?.duration,
              value: eachPrescription?.duration
            }}
            isClearable={true}
            onChange={(selectedOption: any) => {
              onValueChange("duration", selectedOption?.value, index);
              setInputValueDuration(selectedOption ? selectedOption.value : '');
            }}
            onInputChange={(inputValue) => handleChangeDuration({ value: inputValue, label: inputValue })}
            options={options1}
            isDisabled={!isEditable || isReadOnly || freezePrescription}
          />
        </td>
        <td ref={tdRef} className={`col-md-6 treatment-plan-row-td ${!isEditable || isReadOnly || freezePrescription ? "disabled" : ""}  `} title={eachPrescription?.instructions} style={{ margin: 0, padding: 0, height: 'max-content' }}>
          <textarea
            rows={1}
            style={{
              minHeight: "38px", paddingTop: "8px", paddingLeft: "13px", border: "none", height: "100%", display: "flex", alignItems: "center", flex: 1, resize: "none",
              overflow: "hidden"
            }}
            className="consultant-dose-con"
            onChange={(e) => {
              onValueChange("instructions", e.target.value, index);
            }}
            value={eachPrescription?.instructions}
            disabled={!isEditable || isReadOnly || freezePrescription}
          />
        </td>

        <td className="col-md-1" >
          <input
            disabled={!isEditable || isReadOnly || freezePrescription}
            type="checkbox"
            checked={eachPrescription?.sideEffectCheck}
            onChange={(e) => onValueChange("sideEffectCheck", e.target.checked, index)}
          />
        </td>
        <td style={{ margin: 0, padding: 0 }}>
          {lengthMed > 1 ? (isEditable && !isReadOnly && !freezePrescription && (
            <div
              className="delete-icon"
              onClick={() => {
                onDelete(index)
              }}
            >
              <img src="../../../../assets/images/delete-icon.svg" alt="" style={{ paddingRight: "6px" }} />
            </div>
          )) : (
            isEditable && !isReadOnly && !freezePrescription && (
              <div
                className="delete-icon"
                style={{ cursor: "not-allowed" }}
              >
                <img src="../../../../assets/images/delete-icon.svg" alt="" style={{ paddingRight: "6px" }} />
              </div>
            )
          )}
        </td>
      </tr>
      {showdrugValidation && (
        <Toast
          textMessage={`Check the UpperLimit ${drugDosage?.upperLimit === null ? "" : drugDosage?.upperLimit}`}
          onCloseText={"Close"}
          type={"error"}
          onClose={() => setShowdrugvalidation(false)}
        ></Toast>
      )}
    </>

  )
}
